export default {
    associatedLeads: [],
    customerId: null,
};
